import React from 'react';
import { faInfoCircle } from '@fortawesome/free-solid-svg-icons/faInfoCircle';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import AlertStatic from 'buyside/components/presentation/AlertStatic/alertStatic';

import styles from './quickPositionsOverviewStyles.scss';

const AboutQuickPositions: React.FC = () => {
  return (
    <>
      <AlertStatic>
        <span>
          Open a quick position and track its performance over time. By opening a position, you will
          also join a live chat with your peers that also have interest in the name. Close your
          position at an appropriate time to lock in the return.
        </span>
      </AlertStatic>
      <div className={styles.exampleGroup}>
        <div className={styles.exampleTitle}>
          <FontAwesomeIcon icon={faInfoCircle} />
          Take a quick position by visiting an <em>idea</em> or <em>company</em> page of the
          security you are watching.
        </div>
        <div className={styles.exampleImages}>
          <img src="/images/pro/quick_position_idea_example.png" />
          <img src="/images/pro/quick_position_entity_example.png" />
        </div>
      </div>
      <div className={styles.exampleGroup}>
        <div className={styles.exampleTitle}>
          <FontAwesomeIcon icon={faInfoCircle} />
          View community consensus on the security you have taken a position on.
        </div>
        <div className={styles.exampleImages}>
          <img
            className={styles.consensusImage}
            src="/images/pro/quick_position_consensus_example.png"
          />
        </div>
      </div>
      <div className={styles.exampleGroup}>
        <div className={styles.exampleTitle}>
          <FontAwesomeIcon icon={faInfoCircle} />
          Keep track of your positions and close them to realize your virtual gains/losses.
        </div>
        <div className={styles.exampleImages}>
          <img src="/images/pro/quick_position_table_example.png" />
        </div>
      </div>
      <div className={styles.exampleGroup}>
        <div className={styles.exampleTitle}>
          <FontAwesomeIcon icon={faInfoCircle} />
          Chat with peers that also have interest in the name.
        </div>
        <div className={styles.exampleImages}>
          <img src="/images/pro/quick_position_chat_example.png" />
        </div>
      </div>
    </>
  );
};

export default AboutQuickPositions;
